module.exports = __webpack_public_path__ + "images/category_lp/earphone/new/store_images/2@2x_b8bef68bb99b20259e0a085e53be5923.png";